import { Component, OnInit, inject, DestroyRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { translate } from '@jsverse/transloco';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ConfirmationDialogComponent } from 'src/app/components/confirmation-dialog/confirmation-dialog.component';
import { ErrorDialogComponent } from 'src/app/components/error-dialog/error-dialog.component';
import { Constants } from 'src/app/models/constants';
import { PermissionService } from 'src/app/services/api/permission.service';
import { FormUtilService } from 'src/app/services/util/form-util.service';
import { SidenavService } from 'src/app/services/util/sidenav.service';
import { CustomToastrService } from 'src/app/services/util/toastr.service';

@Component({
    selector: 'app-add-group',
    templateUrl: './add-group.component.html',
    styleUrls: ['./add-group.component.scss'],
    standalone: false
})
export class AddGroupComponent  implements OnInit {

  Constants = Constants;
  groupForm: FormGroup;
  showLoader = false;
private destroyRef = inject(DestroyRef);
  constructor(private fb: FormBuilder, private sidenavService: SidenavService,
    private dialog: MatDialog, private permissionsService: PermissionService,
    private toastrService: CustomToastrService) {
   
 }

  ngOnInit(): void {
    const formConfig: any = {
      name: ['', [Validators.required, Validators.maxLength(30), Validators.pattern(/^[a-zA-Z\-\ ]+$/)]],
      description: ['', [Validators.required, Validators.maxLength(150)]],
    };
    this.groupForm = this.fb.group(formConfig);
  }

  closeSidenav(): void {
    this.sidenavService.closeRightSidenav();
  }

  onSubmit(): void {
    if(!FormUtilService.validateForm(this.groupForm)) {
      return;
    }
    this.addGroup();
  }

  cancel(): void {
    this.groupForm.reset();
  }

  addGroup(): void {
    const isFormValid = FormUtilService.validateForm(this.groupForm);
    if (isFormValid) {
      this.dialog.open(ConfirmationDialogComponent, {
        panelClass: 'default-dialog-wrapper',
        width: '566px',
        autoFocus: false,
        data: {
          title: translate('GROUPS.ADD_GROUP_HEADER'),
          message: translate('GROUPS.ADD_GROUP_MESSAGE'),
          confirmButtonText: translate('BUTTONS.CONFIRM')
        }
      })
      .afterClosed()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(confirm => {
        if (confirm) {
          const formData = this.groupForm.getRawValue();
          formData.name = formData.name.split(' ').join('-');
          this.showLoader = true;
          this.permissionsService.postGroups(formData)
          .pipe(takeUntilDestroyed(this.destroyRef))
          .subscribe(data => {
            if (data) {
              setTimeout(() => {
              const title = translate('GROUPS.GROUPS'); 
              const message = translate('GROUPS.GROUP_ADDED');
              this.toastrService.successMessage(message, title);
            }, 500);
              this.sidenavService.closeRightSidenav(true);
              this.showLoader = false;
            }
          },
          (error) => {
            this.showLoader = false;
            const errorMessage = typeof error === 'string' ? error: typeof error?.error === 'string' ? error.error : error;
            this.dialog.open(ErrorDialogComponent, {
              minHeight: '342px',
              width: '630px',
              panelClass: 'flex-dialog',
              data: {
                title:  translate('GROUPS.GROUP_ADDITION_FAILED'),
                description: errorMessage,
                hideReportButton: true
              }
            });
          });
        }
      });
    }
  }

  keycloakClick(): void {
    const realm = window.location.pathname?.split('/')[1];
    const url = `https://keycloak.shs.saas.temenos.cloud/admin/${realm}/console/#/${realm}/groups`;
    window.open(url, '_blank');
  }

}
